<template>
	<div class="mt-s40">

		<div class="bg-light-gray text-t14 uppercase px-s20 py-s15 hidden grid-cols-cart-grid m_650:grid">
			<p class="text-center">Proizvod</p>
			<p class="pl-s40">Detalji</p>
			<p class="text-center">Količina</p>
			<p class="text-right">Cena</p>
		</div>

		<div class="bg-light-gray text-t14 uppercase px-s20 py-s15 block m_650:hidden">
			<p>Proizvodi</p>
		</div>


		<div class="text-t14 p-s20 grid grid-cols-full items-center border-b border-light-gray mt-s5 m_650:grid-cols-cart-grid" v-for="(item) in getCartItems">
			<a :href="item.options.path">
				<img :src="item.options.thumbnail" :alt="item.name" class="w-s150 mx-auto m_650:w-full"
            width="120" height="182" loading="lazy">
			</a>
			<div class="text-center m_650:text-left m_650:pl-s40">
				<p class="font-medium">{{ item.options.brend }}</p>
				<p>{{ item.name }}</p>
				<p>{{ item.options.code }}</p>
				<p>Boja: {{ item.options.color }}</p>
				<p>Veličina: {{ item.options.size }}</p>
				<p v-if="item.options.changed">Promenjena cena</p>
			</div>

			<div class="text-t14 text-center">
				<p><span class="inline m_650:hidden">Količina:</span> {{ item.qty }}</p>
			</div>

			<div class="text-t14 text-center font-medium mt-s10 m_650:mt-0 m_650:text-right">
				<p>{{ formatPrice(item.options.final_price) }} RSD</p>
			</div>
		</div>

	</div>
</template>

<script>
import accounting from "accounting";

export default {
	name: "CheckoutProductsTable",

	computed: {

		/**
		 * Retrieve cart items from vuex store
		 * That means on every change of vuex state, retrieve changes...
		 */
		getCartItems() {

			return this.$store.getters['Cart/getCartItems'];
		},

	},

	methods: {

		/**
		 * Format price.
		 *
		 * @param value
		 */
		formatPrice(value) {

			return accounting.formatMoney(value, '', 2, '.', ',')
		},
	}

}
</script>
